import * as React from "react";

export const CustomerIcon = ({ props }: any) => {
  return (
    <svg width={31} height={31} viewBox="0 0 31 31" fill="none" {...props}>
      <rect width={31} height={31} rx={8} fill="#fff" />
      <rect
        x={0.5}
        y={0.5}
        width={30}
        height={30}
        rx={7.5}
        stroke="#4C5CFB"
        strokeOpacity={0.1}
      />
      <path
        d="M16.91 21.273v-1.364c0-.723-.183-1.417-.507-1.928-.324-.512-.763-.8-1.221-.8h-3.455c-.458 0-.897.288-1.221.8-.324.511-.506 1.205-.506 1.928v1.364M13.454 14.454a2.727 2.727 0 100-5.454 2.727 2.727 0 000 5.454zM21 21.273v-1.364a2.726 2.726 0 00-2.045-2.639M18.227 9a2.727 2.727 0 010 5.284"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
